let tarteaucitronJs = {
    init() {

        tarteaucitron.init({
            "privacyUrl": "", /* Privacy policy url */

            "hashtag": "#tarteaucitron", /* Open the panel with this hashtag */
            "cookieName": "tartaucitron", /* Cookie name */

            "orientation": "bottom", /* Banner position (top - bottom) */
            "showAlertSmall": false, /* Show the small banner on bottom right */
            "cookieslist": true, /* Show the cookie list */

            "adblocker": false, /* Show a Warning if an adblocker is detected */
            "AcceptAllCta": true, /* Show the accept all button when highPrivacy on */
            "highPrivacy": false, /* Disable auto consent */
            "handleBrowserDNTRequest": false, /* If Do Not Track == 1, disallow all */

            "removeCredit": true, /* Remove credit link */
            "moreInfoLink": true, /* Show more info link */

            //"cookieDomain": 'preprod.igc-industries.fr' /* Shared cookie for subdomain website */

        });

        //Google Analytics
        tarteaucitron.user.gajsUa = window.cinaps.id_google;
        tarteaucitron.user.gajsMore = function () {
        };
        (tarteaucitron.job = tarteaucitron.job || []).push('gajs');
    }
}

export default tarteaucitronJs;
